import { Link } from "react-router-dom";
import { ArrowRight, Mail, Shield, Truck, Phone, MapPin } from "lucide-react";
import { useEffect, useState } from "react";
import { api, fixAssetUrl } from "../lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/site-settings", { params: { _: Date.now() } }).then((r) => setS(r.data)); }, []);
  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try { await api.post("/newsletter/subscribe", { email }); toast.success("Děkujeme za přihlášení!"); setEmail(""); }
    catch { toast.error("Něco se nepovedlo"); }
  };
  return (
    <footer className="bg-zinc-50 border-t border-zinc-200 mt-32" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-4">
              {s?.logo_url ? (
                <img src={fixAssetUrl(s.logo_url)} alt={s?.brand_name || "Logo"} className="h-10 max-w-[200px] object-contain" data-testid="footer-logo-img"/>
              ) : (
                <>
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-blue-600 to-indigo-600 flex items-center justify-center"><ArrowRight className="w-5 h-5 text-white" strokeWidth={2.5}/></div>
                  <div className="font-display font-bold text-xl">{s?.brand_name || "Správný Směr"}</div>
                </>
              )}
            </div>
            <p className="text-sm text-zinc-600 leading-relaxed max-w-md mb-6">{s?.footer_about || "Digitální licence se solidním přístupem."}</p>
            <form onSubmit={subscribe} className="flex gap-2 max-w-md" data-testid="newsletter-form">
              <input value={email} onChange={(e)=>setEmail(e.target.value)} type="email" placeholder="Váš e-mail" required className="flex-1 px-4 py-2.5 rounded-full bg-white border border-zinc-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500" data-testid="newsletter-email"/>
              <button className="btn-primary px-5 py-2.5 rounded-full text-sm font-semibold" data-testid="newsletter-submit">Odebírat</button>
            </form>
            <div className="mt-8 flex flex-wrap gap-6">
              <div className="flex items-center gap-2 text-xs text-zinc-600"><Truck className="w-4 h-4 text-blue-600"/>Okamžité doručení</div>
              <div className="flex items-center gap-2 text-xs text-zinc-600"><Shield className="w-4 h-4 text-blue-600"/>Ověřené licence</div>
              {s?.footer_email && <div className="flex items-center gap-2 text-xs text-zinc-600"><Mail className="w-4 h-4 text-blue-600"/>{s.footer_email}</div>}
              {s?.footer_phone && <div className="flex items-center gap-2 text-xs text-zinc-600"><Phone className="w-4 h-4 text-blue-600"/>{s.footer_phone}</div>}
            </div>
          </div>
          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-widest text-zinc-500 mb-4 font-semibold">Podpora</div>
            <div className="flex flex-col gap-2">
              <Link to="/podpora" className="text-sm text-zinc-700 hover:text-blue-600">Podpora</Link>
              <Link to="/kontakt" className="text-sm text-zinc-700 hover:text-blue-600">Kontakt</Link>
              <Link to="/faq" className="text-sm text-zinc-700 hover:text-blue-600">Časté dotazy</Link>
              <Link to="/reklamace" className="text-sm text-zinc-700 hover:text-blue-600">Reklamace</Link>
              <Link to="/blog" className="text-sm text-zinc-700 hover:text-blue-600">Blog</Link>
            </div>
          </div>
          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-widest text-zinc-500 mb-4 font-semibold">Právní</div>
            <div className="flex flex-col gap-2">
              <Link to="/obchodni-podminky" className="text-sm text-zinc-700 hover:text-blue-600">Obchodní podmínky</Link>
              <Link to="/gdpr" className="text-sm text-zinc-700 hover:text-blue-600">GDPR / Ochrana osobních údajů</Link>
              <Link to="/cookies" className="text-sm text-zinc-700 hover:text-blue-600">Cookies</Link>
              <Link to="/odstoupeni" className="text-sm text-zinc-700 hover:text-blue-600">Odstoupení / Vrácení</Link>
              <Link to="/digital-disclaimer" className="text-sm text-zinc-700 hover:text-blue-600">Digitální zboží</Link>
            </div>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-zinc-200 flex flex-col md:flex-row justify-between gap-4 text-xs text-zinc-500">
          <div>{s?.footer_copyright || "© 2026 Správný Směr"} • IČ: {s?.footer_ic || "CZ19915535"} • {s?.footer_owner || "provozovatel: Tomáš Němeček"}</div>
          <div className="flex items-center gap-1"><MapPin className="w-3 h-3"/>{s?.footer_city || "Veselí nad Moravou, Česká republika"} • spravnysmer.eu</div>
        </div>
      </div>
    </footer>
  );
}
